import { render, staticRenderFns } from "./Uppy.vue?vue&type=template&id=7b5bc17f&scoped=true&"
import script from "./Uppy.vue?vue&type=script&lang=ts&"
export * from "./Uppy.vue?vue&type=script&lang=ts&"
import style0 from "./Uppy.vue?vue&type=style&index=0&id=7b5bc17f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5bc17f",
  null
  
)

export default component.exports